import * as types from "./mutation-types";
import * as investmentService from "../pages/investment/investment.service";
import Vue from "vue";
const vm = new Vue();

/**========================================================================
 *todo                         MASCARAS
 *========================================================================**/

/**========================================================================
 **                           ADICIONAR MASCARAS
 *@param message
 *@return array
 *========================================================================**/
export const addMask = ({ dispatch }, message) => {
  let fixedMasks = ["GAIN_LIMIT", "LOSS_LIMIT", "TRADES_LIMIT", "TIME_LIMIT", "EXTERNAL_ACTION", "REJECTED_ORDER"];
  if (document.hidden) return;
  dispatch(
    "investment/updateByInvestmentId",
    {
      investmentId: Number(message.data.investment_id),
      mask: {
        type: message.data.notif_type || message.data.event,
        fixedMask:
          fixedMasks.includes(message.data.notif_type) || fixedMasks.includes(message.data.event) ? true : false,
        result: message.data.result ? Number(message.data.result) : null,
      },
    },
    { root: true }
  ).catch((err) => {
    console.error(err);
  });
};

/**========================================================================
 **                           REMOVER MASCARA
 *@param  investment_id
 *@param  mask
 *@return array
 *========================================================================**/
export const removeMask = ({ commit, state }, payload) => {
  try {
    const investments = state.investment;
    const index = investments.findIndex((item) => item.investment_id === payload.investment_id);

    let masks = investments[index].masks_list;
    let indexMask = masks.findIndex((item) => item.type === payload.mask.type);

    masks.splice(indexMask, 1);

    let newItem = {};
    if (index != -1) {
      newItem = { ...investments[index], masks_list: masks };
    }

    commit(types.UPDATE_INVESTMENT, { index, data: newItem });
  } catch (err) {
    console.error(`Error in action 'removeMask'`);
  }
};

/**========================================================================
 *todo                         INVESTIMENTOS
 *========================================================================**/

/**========================================================================
 **                           LISTAR INVESTIMENTOS
 *@return array
 *========================================================================**/
export const getInvestments = ({ commit, rootState, dispatch, getters, rootGetters }, payload) => {
  return new Promise(async (resolve, reject) => {
    investmentService
      .getInvestments()
      .then((res) => {
        let body = {
          events: rootState.eventAndNotification.events,
          investments: res.map((item) => {
            let obj = {
              ...item,
              max_gain: undefined,
              max_loss: undefined,
              limit_type: undefined,
              qtd_volume: undefined,
              fin_volume: undefined,
              // open_pnl: 0,
            };
            if (obj.strategy_symbol === "ANY" && obj.curr_positions?.length) {
              obj.curr_positions.forEach((position) => {
                position.open_pnl = newUpdateMarketdata(
                  position.position_status,
                  position.position_symbol,
                  Number(position.symbol_last_price),
                  position.position_price_avg,
                  position.position_volume
                );
              });
              obj.open_pnl = obj.curr_positions.reduce((acc, curr) => acc + (curr.open_pnl || 0), 0);
            } else if (item.type === "PORTFOLIO" && item.status === "RUNNING") {
              obj.masks_list = [];
              obj.sub_strategies.forEach((strategy) => {
                // console.log(strategy);
                strategy.parent_id = item.investment_id;
                strategy.open_pnl = newUpdateMarketdata(
                  strategy.position_status,
                  strategy.position_symbol,
                  Number(strategy.symbol_last_price),
                  strategy.position_price_avg,
                  strategy.position_volume
                );
                // strategy.closed_pnl = 0;
                // strategy.position_profit = 0;
              });

              obj.open_pnl = obj.sub_strategies.reduce((acc, curr) => acc + (curr.open_pnl || 0), 0);

              // tratar array de ativos
              obj.strategy_symbol = Array(...new Set(obj.sub_strategies.map((item) => item.strategy_symbol)));
            }
            return obj;
          }),
        };
        commit(types.GET_INVESTMENT, body);
        // dispatch("setGainLoss", false).catch(() => {});
        if (payload && rootGetters["config/getWebsocketIsConnected"]) {
          const { uuid, type, accountChange } = payload;
          vm.worker.sendMessage({
            type: "CONSUME",
            data: {
              topics: getters.getTopics,
              uuid,
              type,
              accountChange,
            },
          });
        }

        resolve(res);
      })
      .catch((err) => {
        let body = {
          events: rootState.eventAndNotification.events,
          investments: [],
        };
        commit(types.GET_INVESTMENT, body);
        reject(err);
      });
  });
};

// +------------------------------------------------------------------------------+
// | LISTA TODAS AS OPÇÕES DE CONFIGURAÇÕES DE PARÂMETROS                         |
// +------------------------------------------------------------------------------+
export const getParameterSettings = ({ commit }, investmentId) => {
  return new Promise(async (resolve) => {
    try {
      const response = await investmentService.getParameterSettings(investmentId);
      commit(types.GET_PARAMETER_SETTINGS, response);
      resolve(response);
    } catch (error) {
      /** error */
    }
  });
};

// +------------------------------------------------------------------------------+
// | START DO INVESTIMENTO                                                        |
// +------------------------------------------------------------------------------+
export const checkCode_StartBot = (
  {},
  { investment_id, account_id, typed_volume, type, param_id, volume_type, user_code }
) => {
  return new Promise(async (resolve, reject) => {
    if (type == "PORTFOLIO") {
      try {
        const response = await investmentService.startBotPortfolio({
          investment_id,
          account_id,
          typed_multiple: typed_volume,
          param_id,
          user_code,
        });
        resolve(response);
      } catch (err) {
        console.error(err);
        reject(err);
      }
    } else {
      try {
        const response = await investmentService.startBot({
          investment_id,
          account_id,
          typed_volume,
          param_id,
          volume_type,
          user_code,
        });
        resolve(response);
      } catch (err) {
        console.error(err);
        reject(err);
      }
    }
  });
};

// +------------------------------------------------------------------------------+
// | STOP DO INVESTIMENTO                                                         |
// +------------------------------------------------------------------------------+
export const checkCode_StopBot = ({}, payload) => {
  let type = payload.type;
  delete payload.type;

  return new Promise(async (resolve, reject) => {
    try {
      if (type == "PORTFOLIO") {
        const response = await investmentService.stopBotPortfolio(payload);
        resolve(response);
      } else {
        const response = await investmentService.stopBot(payload);
        resolve(response);
      }
    } catch (error) {
      if (Object(error).hasOwnProperty("validation_error")) {
        reject("Assinatura eletrônica deve ter 4 caracteres.");
      }
      if (Object(error).hasOwnProperty("msg")) {
        reject(error.msg);
      }
    }
  });
};

export const stopAll = ({}, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await investmentService.stopAll(payload);
      resolve(response);
    } catch (error) {
      reject(error.data);
    }
  });
};

/**========================================================================
 **                           ATUALIZAR INVESTIMENTO
  @param investment_id  
  @param position_price 
  @param position_volume
  @param position_profit
  @param open_pnl
  @return array
 *========================================================================**/
export const updateByInvestmentId = ({ commit, state }, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const {
        investmentId,
        position_status,
        position_volume,
        position_price_avg,
        position_profit,
        closed_pnl,
        open_pnl,
        mask,
        position_symbol,
        position_type,
      } = payload;
      const investments = state.investment;

      let index = investments.findIndex((item) => {
        if (item?.sub_strategies) {
          return item.sub_strategies.some((sub) => sub.investment_id == investmentId);
        }
        return item.investment_id == investmentId;
      });

      if (index == -1) return;

      const investment = investments[index];

      let isMultiSymbol = investment.strategy_symbol === "ANY" && investment.hasOwnProperty("curr_positions");

      let isPortfolioComponent =
        investment.hasOwnProperty("sub_strategies") &&
        investment.sub_strategies.some((sub) => sub.investment_id === investmentId);

      let subStratIndex = isPortfolioComponent
        ? investment.sub_strategies.findIndex((sub) => sub.investment_id == investmentId)
        : null;
      let newItem = { ...investments[index] };
      let newSubStrat = isPortfolioComponent ? { ...newItem.sub_strategies[subStratIndex] } : null;

      const props = ["position_status", "position_volume", "position_price_avg", "position_profit", "open_pnl"];

      if (isPortfolioComponent) {
        for (let prop of props) {
          newSubStrat[prop] = payload[prop];
        }
        if (closed_pnl) {
          newItem.closed_pnl = closed_pnl;
        }
        newItem.sub_strategies[subStratIndex] = newSubStrat;
        newItem.open_pnl = newItem.sub_strategies.reduce((acc, curr) => acc + Number(curr.open_pnl), 0);
      } else if (isMultiSymbol) {
        let newPosition = {};
        for (let prop of props) {
          newPosition[prop] = payload[prop];
        }
        newPosition.position_symbol = position_symbol;
        if (position_type === "CLOSE") {
          newPosition.open_pnl = 0;
        }

        const positionIndex = newItem.curr_positions.findIndex(
          (pos) => pos.position_symbol === newPosition.position_symbol
        );
        if (positionIndex == -1) {
          newItem.curr_positions.push(newPosition);
        } else {
          newItem.curr_positions.splice(positionIndex, 1, newPosition);
        }
      } else {
        for (let prop of props) {
          newItem[prop] = payload[prop];
        }
      }

      if (closed_pnl && newItem.type !== "PORTFOLIO") {
        newItem.closed_pnl = closed_pnl;
      }

      if (mask && newItem.masks_list.findIndex((item) => item.type == mask.type && item.result == mask.result) == -1) {
        newItem.masks_list.push(mask);
      }

      if (!Object.keys(newItem).length) {
        throw "newItem is empty";
      }
      commit(types.UPDATE_BY_INVESTMENT_ID, { index, data: newItem });
      resolve({ index, data: newItem });
    } catch (error) {
      reject(error);
    }
  });
};

/**========================================================================
 **                           ATUALIZAR DADOS DO MARKETDATA NO ARRAY
 *@param investmentId
 *@param last_price
 *@return array
 *========================================================================**/
export const updateByMarketdata = ({ commit, state }, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { investmentId, last_price } = payload;
      const investments = state.investment;
      let index = investments.findIndex((x) => Number(x.investment_id) == investmentId);
      let isPortfolioComponent = false;
      let componentIndex = null;
      if (index === -1) {
        let newIndex = investments.findIndex(
          (item) =>
            item.status === "RUNNING" &&
            item.type === "PORTFOLIO" &&
            item?.sub_strategies.map((sub) => sub.investment_id).includes(investmentId)
        );

        if (newIndex !== -1) {
          index = newIndex;
          componentIndex = investments[index].sub_strategies.findIndex((sub) => sub.investment_id === investmentId);
          isPortfolioComponent = true;
        } else {
          throw new Error("Índice não encontrado");
        }
      }
      let open_pnl;
      if (isPortfolioComponent) {
        open_pnl = updateMarketdata(investments[index].sub_strategies[componentIndex], last_price);
        let newItem = {};
        if (index != -1) {
          newItem = { ...investments[index] };
          newItem.sub_strategies[componentIndex].open_pnl = Number(open_pnl);
          newItem.open_pnl = newItem.sub_strategies.reduce((acc, curr) => acc + Number(curr.open_pnl), 0);
        }
        if (!Object.keys(newItem).length) {
          throw "newItem is empty";
        }
        commit(types.UPDATE_BY_INVESTMENT_ID, { index, data: newItem });
        resolve({ index, data: newItem });
      } else {
        open_pnl = updateMarketdata(investments[index], last_price);
        let newItem = {};
        if (index != -1) {
          newItem = { ...investments[index], open_pnl: Number(open_pnl) };
        }
        if (!Object.keys(newItem).length) {
          throw "newItem is empty";
        }
        commit(types.UPDATE_BY_INVESTMENT_ID, { index, data: newItem });
        resolve({ index, data: newItem });
      }
    } catch (error) {
      /** error */
      reject(error);
    }
  });
};

// export const updateByMarketdata = ({ commit, state }, payload) => {
//   try {
//     const { investmentId, last_price } = payload;
//     const investments = state.investment;

//     const running_investments = investments.filter(
//       (item) => item.status === "RUNNING"
//     );
//     const running_portfolios = running_investments.filter(
//       (item) => item.type === "PORTFOLIO"
//     );

//     const isPortfolio =
//       running_portfolios.findIndex((portfolio) =>
//         portfolio.sub_strategies.some(
//           (sub) => sub.investment_id == investmentId
//         )
//       ) !== -1;

//     console.log("isPortfolio", isPortfolio);
//   } catch (err) {
//     console.error(err);
//   }
// };

/**========================================================================
 **                           ATUALIZAR DADOS DO MARKETDATA NO ARRAY (para estratégias multiativo)
 *@param investment_id
 *@param position_index
 *@param last_price
 *@return array
 *========================================================================**/
export const updatePositionByMarketdata = ({ commit, state }, payload) => {
  return new Promise(async (resolve) => {
    try {
      const { investment_id, last_price, position_index } = payload;
      const investments = state.investment;
      const index = investments.findIndex((x) => Number(x.investment_id) == investment_id);
      let open_pnl = updateMarketdata(investments[index].curr_positions[position_index], last_price);

      let newItem = {};
      if (index != -1) {
        newItem = { ...investments[index] };
        if (open_pnl) {
          newItem.curr_positions[position_index].open_pnl = open_pnl;
        }
      }
      newItem.open_pnl = newItem.curr_positions.reduce((acc, curr) => acc + curr.open_pnl, 0);
      if (!Object.keys(newItem).length) {
        throw "newItem is empty";
      }
      commit(types.UPDATE_BY_INVESTMENT_ID, { index, data: newItem });
      resolve({ index, data: newItem });
    } catch (error) {
      /** error */
      reject(error);
    }
  });
};

/**========================================================================
 **                           MESSAGEM RECEBIDA DO WEBSOCKET
 *@param message
 *@param account_id
 *========================================================================**/
export const messageWebsocketInvestmentStart = ({ dispatch, rootState }, payload) => {
  let { message, account_id } = payload;
  // console.log(message);
  if (account_id == message.account_id) {
    dispatch("updateByInvestmentId", {
      investmentId: Number(message.investment_id),
      position_status: message.position_type,
      position_volume: parseFloat(message.position_volume_current),
      position_price_avg: parseFloat(message.position_price_avg),
      position_profit: Number(message.position_profit),
      mask: {
        type: "NEW_POSITION",
        fixedMask: false,
        investment_id: message.investment_id,
      },
      position_symbol: message.position_symbol,
    })
      .then(() => {
        // if (rootState.eventAndNotification.events["NEW_POSITION"].length > 0) {
        //   dispatch("startingTopics");
        // }
      })
      .catch(() => {});
  }
};

/**========================================================================
 **                           FECHAR POSIÇÃO DA ESTRATÉGIA
 *@param message
 *@param account_id
 *========================================================================**/
export const messageWebsocketInvestmentStop = ({ dispatch }, payload) => {
  const { message, account_id } = payload;
  const { summed_pnl, position_profit } = message;
  // console.log(payload);
  if (account_id == message.account_id) {
    let obj = {
      investmentId: Number(message.investment_id),
      position_status: "Zerado",
      position_volume: 0,
      position_price_avg: 0,
      position_profit: 0,
      closed_pnl: summed_pnl,
      open_pnl: 0,
      position_symbol: message.position_symbol,
      position_type: "CLOSE",
    };
    // console.log("position_profit", position_profit);
    // console.log("summed_pnl", summed_pnl);
    if (position_profit != undefined && position_profit != null) {
      if (position_profit > 0) {
        obj.mask = {
          type: "TAKE_PROFIT",
          fixedMask: false,
          result: position_profit,
        };
      } else if (position_profit < 0) {
        obj.mask = {
          type: "STOP_LOSS",
          fixedMask: false,
          result: position_profit,
        };
      } else {
        obj.mask = {
          type: "POSITION_CLOSE",
          fixedMask: false,
          result: position_profit,
        };
      }
    } else {
      obj.mask = {
        type: "POSITION_CLOSE",
        fixedMask: false,
        // result: summed_pnl,
      };
    }

    dispatch("updateByInvestmentId", obj)
      .then(() => {
        // dispatch("startingTopics");
      })
      .catch((err) => {
        console.error(err);
      });
  }
};

/**========================================================================
 **                           CALCULO DO PNL
 *@param {Object} investment
 *@param {String} last_price
 *@return number
 *========================================================================**/
function updateMarketdata(investment, last_price) {
  let symbol_details = detailsSymbol(investment.strategy_symbol);
  let adj_position_profit = null;
  if (!last_price) return adj_position_profit;

  if (investment.position_status == "Comprado" || investment.position_status == "BUY") {
    adj_position_profit +=
      ((last_price - investment.position_price_avg) / symbol_details.tick_size) *
      symbol_details.tick_profit *
      investment.position_volume;
    return adj_position_profit;
  } else {
    adj_position_profit +=
      ((investment.position_price_avg - last_price) / symbol_details.tick_size) *
      symbol_details.tick_profit *
      investment.position_volume;
    return adj_position_profit;
  }
}

/**
 * Calcula open pnl
 * @param {*} position_status
 * @param {*} position_symbol
 * @param {*} last_price
 * @param {*} position_price
 * @param {*} position_volume
 * @returns
 */
const newUpdateMarketdata = (position_status, position_symbol, last_price, position_price, position_volume) => {
  let open_pnl;
  let symbol_details = detailsSymbol(position_symbol);
  if (["Comprado", "BUY"].includes(position_status)) {
    open_pnl =
      ((last_price - position_price) / symbol_details.tick_size) * symbol_details.tick_profit * position_volume;
    return open_pnl;
  }
  if (["Vendido", "SELL"].includes(position_status)) {
    open_pnl =
      ((position_price - last_price) / symbol_details.tick_size) * symbol_details.tick_profit * position_volume;
    return open_pnl;
  }
  return 0;
};

function detailsSymbol(symbol) {
  switch (symbol) {
    case "WINFUT":
      return {
        tick_size: 5,
        tick_profit: 1,
      };
    case "WDOFUT":
      return {
        tick_size: 0.5,
        tick_profit: 5,
      };
    case "INDFUT":
      return {
        tick_size: 5,
        tick_profit: 5,
      };
    case "DOLFUT":
      return {
        tick_size: 0.5,
        tick_profit: 25,
      };
    case "CCMFUT":
      return {
        tick_profit: 4.5,
        tick_size: 0.01,
      };
    case "WSPFUT":
      return {
        tick_profit: 0.625,
        tick_size: 0.25,
      };
    case "BITFUT":
      return {
        tick_profit: 2,
        tick_size: 20,
      };
    default:
      return {
        tick_size: 0.01,
        tick_profit: 0.01,
      };
  }
}

export const sendMessage = ({ commit, rootState }) => {
  let account = rootState.accountTypes;
  commit(types.SEND_MESSAGE, account);
};

export const searchInvestment = ({ commit }, payload) => {
  commit(types.SEARCH_INVESTMENT, payload);
};

export const orderInvestment = ({ commit }, payload) => {
  commit(types.ORDER_INVESTMENT, payload);
};

export const addFilters = ({ commit }, payload) => {
  commit(types.FILTERS_INVESTMENT, payload);
};

export const removerFilters = ({ commit }, payload) => {
  commit(types.REMOVER_FILTERS_INVESTMENT, payload);
};

/**========================================================================
 *todo                         EDITAR PARAMETROS DA ESTRATÉGIA
 *========================================================================**/

/**========================================================================
 **                           LISTAR PARAMETROS
 *?  Lista todas as opções de configurações de parâmetros
 *@param investment_id
 *@return array
 *========================================================================**/
export const listParams = async ({ commit }, investment_id) => {
  try {
    const response = await investmentService.listParams(investment_id);
    commit(types.LIST_PARAMS, response);
  } catch (error) {
    /** error */
  }
};

/**========================================================================
 **                           SELECIONAR PARAMETRO
 *? Define o parâmetro selecionado no ato do clique.
 *@param objeto
 *========================================================================**/
export const selectedParam = async ({ commit }, payload) => {
  commit(types.SELECTED_PARAM, payload);
};

/**========================================================================
 **                           LISTA DE PARAMETROS MODAL
 *? Obtém informações sobre o parâmetro informado,
 *? além de todas as seções de parâmetros correspondente ao parâmetro selecionado.
 *@param investment_id
 *@param param_id
 *@return array
 *========================================================================**/
export const getParamInfo = async ({ commit }, payload) => {
  try {
    const response = await investmentService.getParamInfo(payload.investment_id, payload.param_id);
    commit(types.GET_PARAM_INFO, response);
  } catch (error) {
    /** error */
  }
};

/**========================================================================
 **                           SELECIONAR INDICE
 *? Guarda o índice da seção visível ao usuário.
 *@param index
 *========================================================================**/
export const sectionIndex = ({ commit }, payload) => {
  commit(types.SECTION_INDEX, payload);
};

export const resetParam = ({ dispatch }, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await investmentService.resetParam(payload);

      // houve um problema ao resetar.
      if (response.status != "success") reject();

      // atualizar as informações do parâmetro original do desenvolvedor.
      dispatch("investment/getParamInfo", payload, { root: true }).then(() => resolve(response));
    } catch (error) {
      /** error */
    }
  });
};

export const deleteParam = ({ dispatch, rootState }, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await investmentService.deleteParam(payload);

      // houve um problema ao deletar.
      if (response.status != "success") reject();

      // seleciona o parâmetro do desenvolvedor, uma vez que, o parâmetro atual foi deletado.
      let _devParam = rootState.investment.parameters.parameterSettings.filter((x) => x.param_deletable == false)[0];
      dispatch("investment/selectedParam", _devParam, { root: true }).then(() => {
        dispatch("investment/listParams", payload.investment_id, {
          root: true,
        }).then(() => resolve(response));
      });
    } catch (error) {
      /** error */
    }
  });
};

export const createParam = ({ dispatch, rootState }, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await investmentService.createParam(payload);

      // houve um problema ao criar.
      if (response.status != "success") reject();

      // atualiza a lista de parâmetros para pegar o novo parâmetro criado.
      dispatch("investment/listParams", payload.investment_id, {
        root: true,
      }).then(() => {
        let _list_params = rootState.investment.parameters.parameterSettings;

        // define o último parâmetro criado como parâmetro selecionado.
        dispatch("investment/selectedParam", _list_params[_list_params.length - 1], { root: true }).then(() =>
          resolve(response)
        );
      });
    } catch (error) {
      reject({ msg: "Código inválido" });
    }
  });
};

export const updateParam = ({ dispatch, rootState }, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await investmentService.updateParam(payload);

      if (response.status != "success") reject();

      resolve(response);
    } catch (error) {
      /** error */
    }
  });
};

export const selectedParams = ({ commit }, payload) => {
  // console.log(JSON.parse(JSON.stringify(payload)));
  commit(types.SELECTED_PARAMS_INVESTMENT, payload);
};

export const setVisualizationMode = ({ commit }, payload) => {
  const isValid = ["card", "mini-card", "list"].includes(payload);
  try {
    if (isValid) {
      commit(types.SET_VISUALIZATION_MODE, payload);
    } else {
      throw "Invalid input (Must be one of: 'card', 'mini-card', 'list')";
    }
  } catch (err) {
    console.error(err);
  }
};

export const setInvestmentVolume = ({ commit }, payload) => {
  commit(types.SET_INVESTMENT_VOLUME, payload);
};

export const setInvestmentVolumeType = ({ commit }, { investment_id, volume_type }) => {
  commit(types.SET_INVESTMENT_VOLUME_TYPE, { investment_id, volume_type });
};

export const setInvestmentVolumeByType = ({ commit }, { investment_id, volume }) => {
  commit(types.SET_INVESTMENT_VOLUME_BY_TYPE, { investment_id, volume });
};

export const setInvestmentSymbolPrice = ({ commit, state }) => {
  const runningInvestments = state.investment.filter(
    (item) => item.strategy_market === "Equities" && item.status === "RUNNING"
  );
  const symbols = Array.from(new Set(runningInvestments.map((item) => item.strategy_symbol)));
  if (symbols.length) {
    vm.$api
      .post(vm.$endpoint.GET_QUOTES, {
        symbols,
      })
      .then(({ data }) => {
        if (data.length) {
          data.forEach(({ symbol, last_price }) => {
            commit(types.SET_INVESTMENT_SYMBOL_PRICE, { symbol, last_price });
          });
        }
      })
      .catch(({ data }) => {
        console.error(data);
      });
  }
};

export const setGainLoss = ({ commit, state }, payload) => {
  return new Promise((resolve, reject) => {
    if (payload?.investment_id) {
      const investment_id = payload.investment_id;
      const index = state.investment.findIndex((item) => item.investment_id === investment_id);
      const item = state.investment[index];
      const isRunning = item.status === "RUNNING";
      const data = {
        running: isRunning ? [investment_id] : undefined,
        stopped: !isRunning
          ? [
              {
                investment_id,
                volume_type: item.volume_type,
                typed_volume: item.curr_volume,
              },
            ]
          : undefined,
      };
      if (Object.values(data) == true) return;
      vm.$api
        .post(vm.$endpoint.CHECK_GAIN_LOSS, data)
        .then(({ data }) => {
          commit(types.SET_GAIN_LOSS, data);
          resolve();
        })
        .catch((err) => {
          // console.error("setGainLoss action error", err);
          reject(err);
        });
    } else if (payload?.running_only) {
      const equities = state.investment.filter((item) => item.strategy_market === "Equities");
      const runningEquities = equities.filter((item) => item.status === "RUNNING");
      const runningEquitiesIds = runningEquities.map((item) => item.investment_id);
      const data = {
        running: runningEquitiesIds,
      };
      if (Object.values(data) == true) return;
      vm.$api
        .post(vm.$endpoint.CHECK_GAIN_LOSS, data)
        .then(({ data }) => {
          commit(types.SET_GAIN_LOSS, data);
          resolve();
        })
        .catch((err) => {
          // console.error("setGainLoss action error", err);
          reject(err);
        });
    } else {
      const equities = state.investment.filter((item) => item.strategy_market === "Equities");
      const runningEquities = equities.filter((item) => item.status === "RUNNING");
      const runningEquitiesIds = runningEquities.map((item) => item.investment_id);
      const stoppedEquities = equities
        .filter((item) => item.status === "STOPPED")
        .map((item) => {
          return {
            investment_id: item.investment_id,
            volume_type: item.volume_type,
            typed_volume: item.curr_volume,
          };
        });
      const data = {
        running: runningEquitiesIds.length ? runningEquitiesIds : undefined,
        stopped: stoppedEquities.length ? stoppedEquities : undefined,
      };
      if (Object.values(data) == true) return;
      vm.$api
        .post(vm.$endpoint.CHECK_GAIN_LOSS, data)
        .then(({ data }) => {
          commit(types.SET_GAIN_LOSS, data);
          resolve();
        })
        .catch(({ data }) => {
          // console.error("setGainLoss action error", data);
          reject(data);
        });
    }
  });
};

export const setParamById = ({ commit }, payload) => {
  commit(types.SET_PARAM_BY_ID, payload);
};

export const setSaveIsEnabled = ({ commit }, payload) => {
  commit(types.SET_SAVE_IS_ENABLED, payload);
};

export const setStringFilter = ({ commit }, payload) => {
  commit(types.SET_STRING_FILTER, payload);
};

export const setRangeFilter = ({ commit }, payload) => {
  commit(types.SET_RANGE_FILTER, payload);
};

export const setToggleFilter = ({ commit }, payload) => {
  commit(types.SET_TOGGLE_FILTER, payload);
};

export const clearActiveFilters = ({ commit }, payload) => {
  commit(types.INVESTMENT_CLEAR_ACTIVE_FILTERS, payload);
};
